// extracted by mini-css-extract-plugin
export default {"noReportsWrapper":"ReportsListNoReport_noReportsWrapper__YvtZo"};